module.exports = __webpack_public_path__ + "img/partner06.f2717124.png";